import { render, staticRenderFns } from "./ForgotPassword.html?vue&type=template&id=33442172&scoped=true&"
import script from "./ForgotPassword.js?vue&type=script&lang=js&"
export * from "./ForgotPassword.js?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.scss?vue&type=style&index=0&id=33442172&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33442172",
  null
  
)

export default component.exports